import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';

import { Null } from '@/components/Null';
import { useActiveOtaPlan } from '@/components/spotter/useActiveOtaPlan';
import { InlineAlert, InlineAlertPrimaryButton, InlineAlertTitle } from '@/components/ui/InlineAlert';
import { useSpotterContext } from '@/context/SpotterContext';

const STATUS_TAB_HREF = '#status';

export type SpotterOtaInProgressAlertProps = {
    children: ReactNode;
    // Scope the dismissal to one page. Omit it to make the alert non-dismissable.
    dismissKey?: string;
    sx?: SxProps<Theme>;
};

export const SpotterOtaInProgressAlert = ({ children, dismissKey, sx }: SpotterOtaInProgressAlertProps) => {
    const { spotterId } = useSpotterContext();
    const otaPlan = useActiveOtaPlan();
    const mixpanel = useMixpanel();

    if (!otaPlan || !spotterId) {
        return <Null data-testid="ota-in-progress-alert-hidden" />;
    }

    return (
        <InlineAlert
            severity="info"
            sx={sx}
            dismissNotificationId={dismissKey ? `ota-in-progress:${dismissKey}:${otaPlan.id}` : undefined}
            notificationContext={{ spotterId }}
            actionButton={
                <InlineAlertPrimaryButton
                    testid="ota-in-progress-alert"
                    component="a"
                    href={STATUS_TAB_HREF}
                    onClick={() => {
                        mixpanel?.track('Click OTA in progress track update', {
                            spotterId,
                            otaPlanId: otaPlan.id,
                        });
                    }}
                >
                    Track update
                </InlineAlertPrimaryButton>
            }
        >
            <InlineAlertTitle testid="ota-in-progress-alert">This system is currently updating</InlineAlertTitle>
            {children}
        </InlineAlert>
    );
};
